const RENTALS_CHANNEL_MANAGER = {
  //getCMPartnerSettings
  RENTALS_CM_PARTNER_SETTINGS: 'RENTALS_CM_PARTNER_SETTINGS',
  //getCMPartnerPropertiesSettings
  RENTALS_CM_PARTNER_PROPERTIES_SETTINGS: 'RENTALS_CM_PARTNER_PROPERTIES_SETTINGS',
  //getCMPartners
  RENTALS_CM_PARTNERS: 'RENTALS_CM_PARTNERS',
  //getCMPartnersOneWay
  RENTALS_CM_PARTNERS_ONEWAY: 'RENTALS_CM_PARTNERS_ONEWAY',
  //getCMPartnerInfo
  RENTALS_CM_PARTNER_INFO: 'RENTALS_CM_PARTNER_INFO',
  //getCMPartnerAccounts
  RENTALS_CM_PARTNER_ACCOUNTS: 'RENTALS_CM_PARTNER_ACCOUNTS',
  //getCMPartnerGuidebooks
  RENTALS_CM_SUGESTIO_GUIDEBOOKS: 'RENTALS_CM_SUGESTIO_GUIDEBOOKS',
  //getCMPartnerAccountSettings
  RENTALS_CM_PARTNER_ACCOUNT_SETTINGS: 'RENTALS_CM_PARTNER_ACCOUNT_SETTINGS',
  //getCMRentalPartnerSettings
  RENTALS_CM_RENTAL_PARTNER_SETTINGS: 'RENTALS_CM_RENTAL_PARTNER_SETTINGS',
  //getCMRentalAccountPartnerData
  RENTALS_CM_RENTAL_ACCOUNT_PARTNER_DATA: 'RENTALS_CM_RENTAL_ACCOUNT_PARTNER_DATA',
  //getMappingAccommodationObjectConfiguration
  RENTALS_CM_MAPPING_ACCOMMODATION_OBJECT_CONFIGURATION:
    'RENTALS_CM_MAPPING_ACCOMMODATION_OBJECT_CONFIGURATION',
  //getMappingAccommodationUnitConfiguration
  RENTALS_CM_MAPPING_ACCOMMODATION_UNIT_CONFIGURATION:
    'RENTALS_CM_MAPPING_ACCOMMODATION_UNIT_CONFIGURATION',
  //getCMUnitPartnerSettings
  RENTALS_CM_UNIT_PARTNER_SETTINGS: 'RENTALS_CM_UNIT_PARTNER_SETTINGS',
  //getCMImportedCalendars
  RENTALS_CM_IMPORTED_CALENDARS: 'RENTALS_CM_IMPORTED_CALENDARS',
  //getCMImportCalendarsPartners
  RENTALS_CM_IMPORTED_CALENDARS_PARTNERS: 'RENTALS_CM_IMPORTED_CALENDARS_PARTNERS',
  //getCMAccommodationConfigurations
  RENTALS_CM_MAPPING_ACCOMMODATION_CONFIGURATIONS:
    'RENTALS_CM_MAPPING_ACCOMMODATION_CONFIGURATIONS',
  //getICalUnit
  RENTALS_CM_ICAL_UNIT: 'RENTALS_CM_ICAL_UNIT',
  RENTALS_CM_FAULTY_ACCOUNTS: 'RENTALS_CM_FAULTY_ACCOUNTS',
  //getRatePlans
  RENTALS_RATE_PLANS: 'RENTALS_RATE_PLANS',
  //getUnitRatePlans
  RENTALS_UNIT_RATE_PLANS: 'RENTALS_UNIT_RATE_PLANS',

  CM_INTEGRATIONS_PARTNER_DETAILS: 'CM_INTEGRATIONS_PARTNER_DETAILS',
};

export default RENTALS_CHANNEL_MANAGER;
